<template>
  <!-- 筛选 -->
  <div class="screen">
    <div class="item clearfix">
      <span class="zu clearfix">
        <span class="d-flex">
          <span class="name">媒体类别</span>
          <platTypeCascader
            title="媒体类别"
            :industryTypeList="mediaLevelList"
            :morenzhi="morenzhi"
            @putData="putData"
          ></platTypeCascader>
        </span>
      </span>
      <span class="zu clearfix">
        <span class="name">定向信源</span>
        <div class="screen-list">
          <label
            class="checkbox-box"
            v-for="(item, index) in configInfo.isFocusList"
            :key="index"
          >
            <label
              class="checkbox-warp fl"
              :class="source.indexOf(item) != -1 ? 'curr' : ''"
            >
              <input
                class="checkbox"
                v-model="source"
                name=""
                type="checkbox"
                :value="index"
              />
              <i class="icons checkbox-icon"></i>
            </label>
            {{ item }}
          </label>
        </div>
      </span>
      <span class="zu clearfix">
        <span class="name">发布地区</span>
        <city @cityCallback="citySelect" ref="myCity" levels="3"></city>
      </span>
      <span class="zu clearfix">
        <span class="name">IP属地</span>
        <city
          ref="cityLocation"
          @cityCallback="cityLocation"
          levels="1"
          type="2"
        ></city>
      </span>
    </div>
    <div class="item clearfix">
      <span class="zu clearfix">
        <span class="name">时间范围</span>
        <div class="clearfix fl">
          <div class="corm fl">
            <a
              class="element"
              :class="{ curr: timeType === 5 }"
              href="javascript:void(0)"
              @click="selectFixedTime(5, 1)"
              >24小时</a
            >
            <a
              class="element"
              :class="{ curr: timeType === 0 }"
              href="javascript:void(0)"
              @click="selectFixedTime(0, 1)"
              >今天</a
            >
            <a
              class="element"
              :class="{ curr: timeType === 1 }"
              href="javascript:void(0)"
              @click="selectFixedTime(1, 1)"
              >昨天</a
            >
            <a
              class="element"
              :class="{ curr: timeType === 2 }"
              href="javascript:void(0)"
              @click="selectFixedTime(2, 1)"
              >近三天</a
            >
            <a
              class="element"
              :class="{ curr: timeType === 3 }"
              href="javascript:void(0)"
              @click="selectFixedTime(3, 1)"
              >近七天</a
            >
            <a
              class="element"
              :class="{ curr: timeType === 4 }"
              href="javascript:void(0)"
              @click="selectFixedTime(4, 1)"
              >自定义</a
            >
          </div>
          <vue-datepicker-local
            v-if="timeType === 4"
            class="fl"
            v-model="timeRange"
            format="YYYY-MM-DD HH:mm:ss"
            :disabledDate="disabledDate"
            show-buttons
            @confirm="selectedDate"
          />
        </div>
      </span>
    </div>
    <div class="item clearfix">
      <span class="name">媒体类型</span>
      <div class="screen-list" v-if="afromType === '1'">
        <div class="corm clearfix">
          <span
            class="element"
            v-for="(item, index) in MediaPlatformList"
            :key="index"
            :class="luyou === item.type ? 'curr' : ''"
            @click="chooseMedia(item.type)"
            >{{ item.name }}</span
          >
        </div>
      </div>
      <div class="screen-list" v-else>
        <div class="corm clearfix">
          <span v-for="(item, index) in MediaPlatformList" :key="index">
            <router-link
              v-if="item.children.length == 0"
              class="element"
              :class="luyou === item.type ? 'curr' : ''"
              :to="{
                path:
                  '' +
                  $parent.$parent.baseUrl +
                  item.path +
                  '?type=' +
                  item.type +
                  '&timeType=' +
                  timeType
              }"
              >{{ item.name }}</router-link
            >
            <span
              v-else
              class="element drop-down"
              :class="{
                curr: $route.path === $parent.$parent.baseUrl + item.path
              }"
              ref="videoPlatform"
            >
              <button class="btn">
                <span class="text">{{ item.name }}</span
                ><i class="icons"></i>
              </button>
              <ul class="option" @mouseleave="leave">
                <li
                  data-show="no"
                  v-for="(items, indexs) in item.children"
                  :key="indexs"
                >
                  <router-link
                    class="db"
                    :to="{
                      path:
                        '' +
                        $parent.$parent.baseUrl +
                        item.path +
                        '?type=' +
                        items.type +
                        '&timeType=' +
                        timeType
                    }"
                    >{{ items.name }}</router-link
                  >
                </li>
              </ul>
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="item mt10 clearfix hotarticlesDetailRadio" v-if="showEmotion">
      <span class="name">情感属性</span>
      <el-radio-group v-model="emotion">
        <el-radio label="全部">全部</el-radio>
        <el-radio label="正面">正面</el-radio>
        <el-radio label="中性">中性</el-radio>
        <el-radio label="负面">负面</el-radio>
      </el-radio-group>
      <!-- <div class="screen-list">
       <label
            class="checkbox-box"
            v-for="(item, index) in emotionList"
            :key="index"
          >
            <label
              class="checkbox-warp fl"
              :class="emotion.indexOf(item.name) != -1 ? 'curr' : ''"
            >
              <input
                class="checkbox"
                v-model="emotion"
                name=""
                type="radio"
                :value="item.name"
              />
              <i class="icons checkbox-icon"></i>
            </label>
            {{ item.name }}
          </label>
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import city from "../../../components/city.vue";
import platTypeCascader from "../../../components/platTypeCascader.vue";
import VueDatepickerLocal from "vue-datepicker-local";
export default {
  components: { city, VueDatepickerLocal, platTypeCascader },
  computed: {
    ...mapState({
      MediaPlatformList: state => state.show.platformList,
      mediaLevelList: state => state.show.mediaLevelList,
      configInfo: state => state.show.configInfo
    })
  },
  props: {
    afromType: {
      type: String,
      default: ""
    },
    showEmotion: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    const min = new Date(2017, 5, 1, 0, 0);
    const max = new Date(2017, 8, 30, 0, 0);
    return {
      platformCondition: {}, //平台条件
      jianRegion: "全国", //地区
      luyou: "total", //当前页面路由type=total
      planId: "", //方案ID
      timeType: 3, //时间乐类型
      timeRange: [min, max], //时间
      source: [0], //信源值
      morenzhi: {},
      newsContentIpLocation: "全国",
      //platformType:[]//平台数据
      emotionList: {
        全部: { name: "全部", num: 0 },
        正面: { name: "正面", num: 0 },
        中性: { name: "中性", num: 0 },
        负面: { name: "负面", num: 0 }
      }, //情感字段
      emotion: "全部"
    };
  },
  mounted() {
    // this.emotion =this.$parent.emotion
    let that = this;
    that.$nextTick(() => {
      that.luyou = that.$route.query.type ? that.$route.query.type : "total"; //获取当前页面url的type
      if (that.$route.query.isFocus != undefined) {
        that.source = JSON.parse(that.$route.query.isFocus);
        that.jianRegion = that.$route.query.pubArea;
        that.newsContentIpLocation = that.$route.query.newsContentIpLocation;
        that.timeType = Number(that.$route.query.timeType);
      }
      that.$refs.myCity.simpleName = that.$route.query.pubArea;
      that.$refs.cityLocation.simpleName =
        that.$route.query.newsContentIpLocation;
      let sdf = JSON.parse(localStorage.getItem("myInfor")); //获取储存筛选条件
      that.initialCondition(sdf);
      // console.log(sdf);
      //that.getPlatformType();
      that.getShieldWords();
      // 获取本地的省份
      this.$axios
        .get(
          "https://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/json/city.json"
        )
        .then(r => {
          that.$parent.provinceList = r.data.shortProvince;
        });
    });
  },
  watch: {
    $route: {
      handler() {
        console.log(this.$route.query.timeType,666666)
        this.luyou = this.$route.query.type; //获取当前页面url的type
        if (this.$route.query.isFocus != undefined) {
          this.source = JSON.parse(this.$route.query.isFocus);
          this.jianRegion = this.$route.query.pubArea;
          this.newsContentIpLocation = this.$route.query.newsContentIpLocation;
          this.$refs.myCity.simpleName = this.$route.query.pubArea;
          this.$refs.cityLocation.simpleName = this.$route.query.newsContentIpLocation;
          this.timeType = Number(this.$route.query.timeType);
        }
      },
      deep: true
    },
    source() {
      let that = this;
      let len = that.source.length;
      if (that.source[0] == 0 && len > 1) {
        //选择非全部
        that.source.splice(0, 1);
      } else if (that.source[len - 1] == 0 && len > 1) {
        that.source = [0];
      }
      if (len === 0) {
        that.source = [0];
      }
      if (that.$route.query.isFocus == undefined) {
        that.conditionSave();
      }
      this.$parent.dataAjax();
    },
    emotion() {
      // let that = this;
      // let len = that.emotion.length;
      // if(that.emotion[0] === '全部' && len > 1){//选择非全部
      //   that.emotion.splice(0,1);
      // }else if((that.emotion[len-1] === '全部' && len > 1)||len == 0){
      //   that.emotion = ['全部'];
      // }
      // if(this.queryFrist == true){
      //   return;
      // }
      // this.$parent.emotion=this.emotion;
      this.$parent.getNewsList();
    }
  },
  created() {
    // 获取缓存方案数据
    this.planId = JSON.parse(sessionStorage.getItem("planStorage")).id;
  },
  methods: {
    leave() {
      // console.log(22222)
      this.$refs.videoPlatform[0].click();
    },
    //获取选中的方案e
    putData(e) {
      //console.log(e)e
      this.$parent.mediaLevel = e;
      this.platformCondition = e; //存储平台参数
      this.conditionSave();
      this.morenzhi = e;
      //数据加载
      this.$parent.endDate_ = this.$utils.getNowDate();
      this.$parent.dataAjax();
    },
    //获取选中的方案
    getPlanvalue(e) {
      //console.log(e)
      this.$parent.mediaLevel = this.$utils.changeArr(e);
      this.platformCondition = this.$utils.changeArr(e); //存储平台参数
      this.conditionSave();
      //数据加载
      this.$parent.dataAjax();
    },
    //切换媒体
    chooseMedia(type) {
      this.luyou = type;
      if (this.timeType == 0) {
        this.$parent.endDate_ = this.$utils.getNowDate();
      }
      this.$parent.platformType = type;
    },
    //页面初始条件
    initialCondition(sdf) {
      let that = this;
      let max = "";
      let min = "";
      let timeType;
      if (this.$route.query.timeType != undefined) {
        timeType = Number(this.$route.query.timeType);
      } else {
        timeType = 4;
      }
      if (sdf == null) {
        //暂无sessionStorage数据
        if (this.$route.query.isFocus != undefined) {
          this.selectFixedTime(Number(this.$route.query.timeType), 0);
        } else {
          this.selectFixedTime(0, 0);
        }
      } else {
        //存在sessionStorage数据
        let pt = sdf.pt; //获取平台数据
        let dq = sdf.dq;
        let ipdq = sdf.ipdq;
        let time = sdf.time; //获取时间数据
        if (pt != "") {
          that.$parent.mediaLevel = pt;
          that.platformCondition = pt;
        }
        if (dq) {
          this.jianRegion = dq;
          this.$refs.myCity.simpleName = dq; //给城市组件赋值
          this.$parent.pubArea = dq;
          this.$parent.curMapName = dq;
        }
        if (ipdq) {
          this.newsContentIpLocation = ipdq;
          this.$refs.cityLocation.simpleName = ipdq; //给城市组件赋值
          this.$parent.newsContentIpLocation = ipdq;
        }
        if (time != "") {
          let start = time[0];
          let end = time[1];
          min = that.dateSplit(start);
          max = that.dateSplit(end);
        }
        this.source =
          typeof sdf.isFocus === "number" ? [sdf.isFocus] : sdf.isFocus;
        this.timeRange = [min, max];
        console.log(this.timeRange, 'sssssssssssssss')
        this.selectFixedTime(timeType, 0);
      }
    },
    // 时间拆分
    dateSplit(date) {
      let zu = date.split(" ");
      let qian = zu[0].split("-");
      let hou = zu[1].split(":");
      let value = new Date(
        qian[0],
        parseInt(qian[1]) - 1,
        parseInt(qian[2]),
        parseInt(hou[0]),
        parseInt(hou[1]),
        parseInt(hou[2])
      );
      return value;
    },
    // 固定时间选择
    selectFixedTime(type, selectType) {
      //type 0是今天 1是昨天 2是近三天 3是近7天 4是自定义 selectType是点击还是一进页面判断
      let that = this;
      if (type === that.timeType && selectType === 1) {
        return;
      }
      let nowTime = this.$utils.getNowDate(); //今天时间
      let n = nowTime.split(" ")[1].split(":"); //拆分当前时分秒
      let h = n[0];
      let m = n[1];
      let s = n[2];
      let min = "";
      let max = "";
      that.timeType = type;
      if (type === 0) {
        min = nowTime.split(" ")[0] + " " + "00:00:00";
        max = nowTime;
      } else if (type === 1) {
        let yesterday = this.$utils.getBeforeDay(nowTime, 1); //前一天
        min = yesterday + " " + "00:00:00";
        max = yesterday + " " + "23:59:59";
        this.$parent.allDataType = "solid"; //昨天的时候要重置父组件数据汇总显示趋势图
      } else if (type === 2) {
        let ptd = this.$utils.getBeforeDay(nowTime, 2); //前三天
        min = ptd + " " + "00:00:00";
        max = nowTime;
      } else if (type === 3) {
        let ptd = this.$utils.getBeforeDay(nowTime, 6); //前三天
        min = ptd + " " + "00:00:00";
        max = nowTime;
        console.log(min, max);
      } else if (type === 5) {
        let ptd = this.$utils.getBeforeDay(nowTime, 1); //24小时
        min = ptd + " " + h + ":" + m + ":" + s;
        max = nowTime;
      } else if (type === 4) {
        // 获取当前时间和7天前时间
        let sdf = JSON.parse(localStorage.getItem("myInfor"));
        if (sdf == null || sdf.time === "") {
          //自定义时已选择时间
          let ptd = this.$utils.getBeforeDay(nowTime, 7); //前三天
          min = ptd + " " + "00:00:00";
          max = nowTime;
        } else {
          min = sdf.time[0];
          max = sdf.time[1];
        }
      }
      let ns = max.split(" "); //时间拆分
      let n1 = ns[0].split("-");
      let n2 = ns[1].split(":");
      let o1 = min.split(" ")[0].split("-");
      let o2 = min.split(" ")[1].split(":");
      let max1 = new Date(n1[0], n1[1] - 1, n1[2], n2[0], n2[1], n2[2]);
      let min1 = new Date(o1[0], o1[1] - 1, o1[2], o2[0], o2[1], o2[2]);
      this.timeRange = [min1, max1];
      //进页面获取时间数据
      that.$parent.startDate = min;
      that.$parent.endDate = max;
      // that.timeRange = [min,max];
      if (selectType === 1) {
        //点击选择时
        that.$parent.endDate_ = null;
        that.$parent.dataAjax();
      }
      that.conditionSave();
    },
    //城市选择
    citySelect(name) {
      this.$parent.pubArea = name;
      this.jianRegion = name; //存储省份参数
      this.conditionSave();
      //数据加载
      this.$parent.curMapName = name;
      this.$parent.endDate_ = this.$utils.getNowDate();
      this.$parent.dataAjax();
    },
    cityLocation(name) {
      this.$parent.newsContentIpLocation = name;
      this.newsContentIpLocation = name; //存储省份参数
      this.conditionSave();
      //数据加载
      this.$parent.endDate_ = this.$utils.getNowDate();
      this.$parent.dataAjax();
    },
    // 时间选择
    selectedDate() {
      let timeRange = this.timeRange;
      let flag = this.$utils.selectTime(
        [
          new Date(this.$utils.dateConversion(timeRange[0], 1)),
          new Date(this.$utils.dateConversion(timeRange[1], 1))
        ],
        this.$store.state.show.configInfo.timeControlWindow
      );
      if (!flag) {
        return;
      }
      //进页面获取时间数据
      this.$parent.startDate = this.$utils.dateConversion(timeRange[0], 1);
      this.$parent.endDate = this.$utils.dateConversion(timeRange[1], 1);
      let day = this.$utils.getDateDiff(
        this.$parent.startDate,
        this.$parent.endDate
      );
      if (day > this.$parent.$parent.timeSection) {
        this.$utils.alertText(
          "时间跨度最大限制" + this.$parent.$parent.timeSection + "天",
          "",
          1500
        );
        return;
      }
      this.conditionSave();
      //数据加载
      this.$parent.dataAjax();
    },
    disabledDate(time) {
      let day = this.$parent.$parent.timeSection; //获取当前用户的时间范围权限
      let nowTime = this.$utils.getNowDate(); //今天时间
      let startDate = this.$utils.getBeforeDay(nowTime, day); //根据时间权限获取最早时间
      let n = nowTime.split(" ");
      startDate = startDate + " " + n[1];
      let number = this.$utils.dateToMillisecond(startDate); //将获取的最早时间转化成毫秒
      if (time.getTime() > new Date().getTime() || time.getTime() < number)
        return true;
      //if(time.getTime() > new Date().getTime()) return true;
    },
    // 条件存储sessionStorage
    conditionSave() {
      let that = this;
      let timeRanges = "";
      let time = JSON.parse(localStorage.getItem("myInfor"))
        ? JSON.parse(localStorage.getItem("myInfor")).time
        : "";
      if (that.timeType === 4) {
        let timeRange = that.timeRange;
        timeRanges = [
          that.$utils.dateConversion(timeRange[0], 1),
          that.$utils.dateConversion(timeRange[1], 1)
        ];
      } else {
        if (time !== "") {
          timeRanges = time;
        }
      }
      // let time = [that.$utils.dateConversion(timeRange[0],1),that.$utils.dateConversion(timeRange[1],1)];
      let condition = {
        pt: that.platformCondition,
        dq: that.jianRegion,
        timeType: that.timeType,
        isFocus: that.source,
        time: timeRanges,
        ipdq: that.newsContentIpLocation
      };
      localStorage.setItem("myInfor", JSON.stringify(condition));
    },
    //媒体选择
    mediaSelect(name) {
      let that = this;
      if (name === "全部") {
        name = "";
      }
      that.$parent.mediaLevel = name;
      that.platformCondition = name; //存储平台参数
      this.conditionSave();
      //数据加载
      that.$parent.endDate_ = this.$utils.getNowDate();
      that.$parent.dataAjax();
    },
    // 获取屏蔽词
    getShieldWords() {
      let that = this;
      that.$api.get(
        "monitor/analysis/remove-words",
        { sid: that.planId },
        r => {
          that.$parent.$parent.returnCode(r, function() {
            that.$parent.shieldKeywords = r.data;
          });
        }
      );
    },
    // 列表跳转
    listJump(type, searchWords) {
      console.log(typeof type);
      let query = {
        type: typeof type == "string" ? type : type.type,
        searchWords: typeof type == "string" ? searchWords : type.searchWords,
        mediaLevel: JSON.stringify(this.$parent.mediaLevel),
        platformType: this.$parent.mediaPlatform,
        pubArea: this.$parent.pubArea,
        startDate: this.$parent.startDate,
        endDate: this.$parent.endDate,
        isFocus: this.source,
        newsContentIpLocation: this.$parent.newsContentIpLocation
      };
      let routeData = this.$router.resolve({
        path: "" + this.$parent.$parent.baseUrl + "/analysisDetail",
        query: query
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/propagationAnalysis/analysisHeader.vue